import { Component, Input } from '@angular/core';

@Component({
  selector: 'liberro-info-box',
  standalone: false,
  templateUrl: './liberro-info-box.component.html',
  styleUrl: './liberro-info-box.component.less'
})
export class LiberroInfoBoxComponent {
  @Input() public icon = '';

}
